import React, { useEffect, useState } from "react";
import { MdVisibility } from "react-icons/md";
import { Table, Button } from "antd";
import "./Styles/JobsDashboard.css"; // Assuming you have a CSS file for styling
import Clock from "../../../asset/svgs/Clock";
import Check from "../../../asset/svgs/Check";
import { useGetJobPosts, useListJobApplications } from "../hooks/useJobs";
import ViewApplicantModal from "../Components/ApplicantModal";
import { NeonHexagonLoader } from "../Components/JobLoader";
import { getUserId } from "../helper";
// import ApplicantsTable from "../Components/JobTable";

const JobsDashboard = () => {
  const [appModal, setAppModal] = useState(false);
  const [selectedApplicant, setSelectedApplicant] = useState(null);
  const [currentPage, setCurrentPage] = useState(1); // Track the current page
  const [pageSize] = useState(10);
  const {
    listJobApplications,
    loading,
    error,
    data: jobs,
  } = useListJobApplications();

  // const {
  //   getJobPostApplicants,
  //   loading: appsDataLoading,
  //   data: jobsApplicantsList,
  // } = useGetJobApplicantByJobId();
  const { getJobPosts, data: jobPosts } = useGetJobPosts();

  const userId = getUserId();
  useEffect(() => {
    const fetchJobs = async () => {
      await listJobApplications({
        user_id: userId,
        page: 1,
        // limit: 10,
        // status: ["pending", "interview"],
      });
    };

    fetchJobs();
  }, [listJobApplications, userId]);

  useEffect(() => {
    const fetchJobPosts = async () => {
      await getJobPosts({
        user_id: userId,
        page: 1,
        category: "",
        job_type: "",
        salary_date: "",
      });
    };

    fetchJobPosts();
  }, [getJobPosts, userId]);
  const totalJobPost = jobPosts?.length;

  // console.log("Job:", jobs);
  const totalApplication = jobs?.length;

  const handleViewApplication = (id) => {
    setAppModal(true);
    setSelectedApplicant(id);
  };
  const handleCloseApplication = () => {
    setAppModal(false);
  };
  const columns = [
    {
      title: "Name",
      dataIndex: "user_name",
      key: "name",
      render: (text) => <span className="position-text">{text}</span>,
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      render: (text) => <span className="position-text">{text}</span>,
    },
    {
      title: "Job Application",
      dataIndex: "job_title",
      key: "job_title",
      render: (text) => <span className="position-text">{text}</span>,
    },
    {
      title: "Action",
      key: "action",
      render: (record) => (
        <Button
          type="link"
          onClick={() => handleViewApplication(record.id)}
          icon={<MdVisibility className="action-icon" />}
          className="action-button"
        >
          View
        </Button>
      ),
    },
  ];
  if (error) return <div>Error: {error}</div>;
  // Ant Design Table Pagination
  const pagination = {
    current: currentPage,
    pageSize: pageSize,
    total: jobs?.length,
    onChange: (page) => {
      setCurrentPage(page); // Update current page
    },
    showSizeChanger: false, // Optional: hide page size changer dropdown
    showQuickJumper: true, // Optional: allow quick jumping to a page
  };
  if (loading)
    return (
      <div
        style={{
          width: "100%",
          height: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <NeonHexagonLoader />
      </div>
    );
  return (
    <div className="dashboard-container">
      {/* Header */}
      <div className="dashboard-header">
        <h1 className="dashboard-title">Dashboard</h1>
        <p className="dashboard-subtitle">
          Manage your hiring journey effortlessly with our all-in-one admin
          dashboard!
        </p>
      </div>

      {/* Stats Cards */}
      <div className="dashboard-content">
        <div className="stats-grid">
          {/* Jobs Posted */}
          <div className="stat-card">
            <div className="stat-content">
              <div className="stat-icon-container green">
                <Clock />
              </div>
              <div className="stat-info">
                <p className="stat-label">Jobs Posted</p>
                <p className="stat-value">{totalJobPost}</p>
              </div>
            </div>
          </div>

          {/* Applications Received */}
          <div className="stat-card">
            <div className="stat-content">
              <div className="stat-icon-container green">
                <Check />
              </div>
              <div className="stat-info">
                <p className="stat-label">Applications Received</p>
                <p className="stat-value">{totalApplication}</p>
              </div>
            </div>
          </div>
        </div>

        {/* Recent Applications */}
        <div className="applications-section">
          <div className="applications-header">
            <h2 className="applications-title">Recent Application</h2>
          </div>

          <div className="table-container">
            <Table
              scroll={{ x: 800 }}
              columns={columns}
              dataSource={jobs}
              loading={loading}
              pagination={pagination}
              className="custom-table"
              rowClassName={(record) =>
                record.highlighted ? "highlighted-row" : ""
              }
            />
          </div>
        </div>
      </div>
      {/* Job Application table */}
      <ViewApplicantModal
        visible={appModal}
        onClose={handleCloseApplication}
        selectedApplicant={selectedApplicant}
        // workflow={selectedWorkflow}
      />
    </div>
  );
};

export default JobsDashboard;
